import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import Icon from 'ziphy-web-shared/basic/assets/images/Icon';
export const getIconByAttachmentType = (type) => {
    if (type === 'medication_prescription')
        return _jsx(Icon, { type: "documentRounded" });
    if (type === 'post_visit_notes')
        return _jsx(Icon, { type: "documentRounded" });
    if (type === 'prescription')
        return _jsx(Icon, { type: "stethoscope" });
    if (type === 'lab_results')
        return _jsx(Icon, { type: "tubes" });
    if (type === 'telehealth_appointment_reminder')
        return _jsx(Icon, { type: "calendarEvent" });
    if (type === 'initial_intake')
        return _jsx(Icon, { type: "documentRounded" });
    if (type === 'encounter')
        return _jsx(Icon, { type: "calendarEvent" });
    return null;
};
